<template>
  <div class="animated fadeIn">
    <div class="form-group row">
      <div class="col-md-4 px-0">
        <DocMenu
          ref="DocMenu"
          :selectFolder="selectFolder"
          :startupFolderId="startupFolderId"
          v-on:selectitem="onSelectFolder"
          v-on:clear="onClear"
          v-on:edit="onEdit"
          v-on:add="onAdd"
          v-on:undelete="onUndelete"
          v-on:showSettings="settings = 'show'"
          v-on:editType="settings = 'type'"
          v-on:editTag="settings = 'tag'"
          v-on:editSubject="settings = 'subject'"
          v-on:back="onBack">
          <!-- v-on:search="onSearch" -->
        </DocMenu>
      </div>
      <div class="col-md-8 pl-1 pr-0">
        <AddFolder
          ref="AddFolder"
          v-model="editFolder"
          v-if="edit"
          v-on:Back="onBackAddFolder"
          v-on:Update="onUpdate"
          v-on:Create="onCreate" />
        <AddType
          ref="addType"
          v-if="settings === 'type'" />
        <AddTag
          ref="addTag"
          v-else-if="settings === 'tag'" />
        <AddSubject
          ref="addSubject"
          v-else-if="settings === 'subject'" />
        <!-- <SearchContent
          ref="SearchContent"
          v-else-if="search"
          v-on:select="onBackSearch" /> -->
        <DocContent
          ref="DocContent"
          v-show="!settings && !edit && !search"
          v-on:fixOpen="onFixOpen" />
      </div>
    </div>
  </div>
</template>
<script>
import DocMenu from './components/menu/docmenu.vue'
import DocContent from './components/content/doccontent.vue'
import AddFolder from './components/folder/addfolder.vue'
import AddType from './components/type/addtype.vue'
import AddTag from './components/tag/addtag.vue'
import AddSubject from './components/subject/addsubject.vue'
// import SearchContent from './components/searchcontent/searchcontent.vue'
import { actionTypes as AccountActions } from '@/store/module/account/actions'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'
import PermissionMixin from '@/store/module/permission/mixin'

export default {
  name: 'ged',
  mixins: [ AccountMixin, CompanyMixin, PermissionMixin ],
  data () {
    return {
      edit: false,
      editFolder: null,
      search: false,
      settings: null
    }
  },
  props: {
    selectFolder: {
      type: Boolean,
      default: false
    },
    startupFolderId: {
      type: String,
      default: null
    }
  },
  components: {
    DocMenu,
    AddFolder,
    DocContent,
    AddType,
    AddTag,
    AddSubject,
    // SearchContent,
    AccountActions
  },
  mounted () {
    this[AccountActions.GET_LOGGED]()
  },
  beforeMount () {
    // this.$nextTick(() => {
    //   var folder = { id: this.startupFolderId }
    //   this.$refs.DocMenu.onOpen(folder)
    // })
  },
  methods: {
    load () {
      if (this.startupFolderId) {
        this.$refs.DocMenu.onLoad()
      }
    },
    onSelectFolder (folder) {
      this.search = false
      this.$nextTick(() => {
        this.$refs.DocContent.load(folder)
      })

      this.$emit('on-selected-folder', folder)
    },
    onClear () {
      this.folder = null
      this.settings = null
      this.search = false
      this.$nextTick(() => {
        this.$refs.DocContent.setData()
      })
    },
    onEdit (folder) {
      this.edit = true
      this.editFolder = folder
      this.$nextTick(() => {
        this.$refs.AddFolder.edit(folder)
      })
    },
    onAdd (folder) {
      this.edit = true
      this.editFolder = folder
    },
    // onSearch (data) {
    //   this.search = true
    //   this.$nextTick(() => {
    //     this.$refs.SearchContent.search(data)
    //   })
    // },
    onBack () {
      this.edit = false
      this.search = false
      this.settings = null
    },
    onBackAddFolder (folder) {
      this.edit = false
      this.search = false
      this.$nextTick(() => {
        this.$refs.DocMenu.onBackAddFolder(this.editFolder)
      })
    },
    onBackSearch (folder) {
      this.search = false
      this.$nextTick(() => {
        this.$refs.DocMenu.loadAllAndOpen(folder)
          .then(() => {
            this.$refs.DocContent.load(folder)
          })
      })
    },
    onUpdate (folder) {
      this.edit = false
      this.$refs.DocMenu.onUpdate(folder)
    },
    onCreate (folder) {
      this.edit = false
      this.$refs.DocMenu.onCreate(folder)
    },
    onUndelete () {
      this.onClear()
      this.$refs.DocContent.isUndeleting = true
    },
    onFixOpen (folder) {
      this.$refs.DocMenu.fixOpen(folder)
    },
    sendingFiles () {
      return this.$refs.DocContent.sendingFiles
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/operational/documents/ged.vue